import axios from "axios";
import React, {
  useEffect,
  useState,
  Fragment,
  useContext,
  useMemo,
} from "react";
import { useHistory, useParams } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import UserDataContext from "../../context/UserDataContext";
import { Link } from "react-router-dom";
import QRCode from "qrcode.react";
import { translate } from "../../translations";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

function EditService() {
  const [error, setError] = useState(false);
  const [payload, setPayload] = useState({});
  const [relatedOrders, setRelatedOrders] = useState([]);
  const [autoOrders, setAutoOrders] = useState([]);
  const token = localStorage.getItem("token");
  const { id } = useParams();
  const { userData } = useContext(UserDataContext);
  const [fieldData, setFieldData] = useState({
    activatedFields: [],
    picklistValues: {},
    kostenstellen: [],
  });
  const history = useHistory();
  const [file, setFile] = useState(null);
  const project = localStorage.getItem("currentProjectID");
  const [deleteCall, setDeleteCall] = useState({ id: "", open: false });
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteOrder, setDeleteOrder] = useState({});
  const [executeAutoOrder, setExecuteAutoOrder] = useState({
    date: "",
    open: false,
  });
  const [deleteAutoOrder, setDeleteAutoOrder] = useState({
    id: "",
    open: false,
  });
  const [dropdownOptions, setDropdownOptions] = useState([]);

  async function getData() {
    const activatedFields = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/editServices/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    const getSettings = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/appSettings/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    let recordData = await axios.get(
      `${process.env.REACT_APP_BACKEND}/services/${id}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setAutoOrders(recordData.data.autoOrders);
    setPayload(recordData.data.service);
    setRelatedOrders(recordData.data.relatedOrders);

    setFieldData({
      activatedFields: activatedFields.data["0"].value.activatedFields,
      settings: getSettings.data["0"].value,
      picklistValues: activatedFields.data["0"].value.picklistValues,
    });
  }

  async function getDropdownOptions() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/dropdownOptions/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setDropdownOptions(userRes.data);
  }

  async function executeAutoOrderCall() {
    let payload = { date: executeAutoOrder.date, autoOrders: [] };
    autoOrders.forEach((ao) => {
      payload.autoOrders.push(ao._id);
    });
    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/auto-order/execute`,
      payload,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setExecuteAutoOrder({ date: "", open: false });
    history.go(0);
  }

  async function deleteService() {
    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/delete/${deleteCall.id}`,
      {},
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    history.push("/services/");
  }

  async function register(e) {
    e.preventDefault();

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/edit/${id}`,
        payload,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      history.push("/services/");
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  async function uploadFile(e) {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("file", document.getElementById("filePicker").files[0]);
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/upload-file/service/${id}`,
        formData,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      history.go(0);
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  const downloadQRCode = () => {
    const qrcode = document.getElementById("qrcode");
    const pngUrl = qrcode
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `qr-code.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  async function deleteOrderCall() {
    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/order/delete/${deleteOrder.orderId._id}`,
      { userData },
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setOpenDelete(false);
    history.go(0);
  }

  async function deleteAutoOrderCall() {
    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/auto-order/delete/${deleteAutoOrder.orderId}`,
      {},
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setDeleteAutoOrder({ id: "", open: false });
    setAutoOrders(
      autoOrders.filter((order) => order._id !== deleteAutoOrder.orderId)
    );
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "status",
        header: "Status",
        enableHiding: false,
      },
      {
        accessorKey: "orderDate",
        header: "Bestelldatum",
        enableHiding: false,
      },
      {
        accessorKey: "orderDoneDate",
        header: "erledigt am",
        enableHiding: false,
      },
      {
        accessorKey: "comment",
        header: "Kommentar",
        enableHiding: false,
      },
      {
        accessorKey: "_id",
        header: "Optionen",
        enableHiding: false,
        Cell: ({ cell }) => (
          <>
            <a href={`/edit-order/${cell.getValue()}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="inline-block mr-2 size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </a>
          </>
        ),
      },
    ],
    []
  );

  let table = useMaterialReactTable({
    columns,
    data: relatedOrders ? relatedOrders : [],
    localization: MRT_Localization_DE,
    initialState: {
      columnOrder: ["status", "orderDate", "orderDoneDate", "comment", "_id"],
    },
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  useEffect(() => {
    getData();
    getDropdownOptions();
  }, [userData]);

  return (
    <>
      <div className="bg-white  overflow-hidden sm:rounded-lg flex justify-center">
        <div className="px-4 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <div className="flex flex-col grow">
            <div class="grid grid-cols-4 gap-4">
              <div class="col-span-3">
                <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className="px-4 py-3 bg-gray-50  sm:px-6">
                    {translate("Leistung_bearbeiten")}
                  </div>
                  <form onSubmit={register}>
                    <div className="shadow overflow-hidden sm:rounded-md">
                      <div className="px-4 py-5 bg-white sm:p-6">
                        <div className="grid grid-cols-6 gap-6">
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes(
                              "werk_standort"
                            ) && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("werk_standort")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      werk_standort: e.target.value,
                                    })
                                  }
                                  value={payload.werk_standort._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field ===
                                          "Werk/Standort"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes(
                              "fachbereich"
                            ) && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("fachbereich")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      fachbereich: e.target.value,
                                    })
                                  }
                                  value={payload.fachbereich._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field === "Fachbereich"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("abteilung") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("abteilung")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      abteilung: e.target.value,
                                    })
                                  }
                                  value={payload.abteilung._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field === "Abteilung"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("gebaeude") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("gebaeude")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      gebaeude: e.target.value,
                                    })
                                  }
                                  value={payload.gebaeude._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field === "Gebäude"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("anlage") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("anlage")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      anlage: e.target.value,
                                    })
                                  }
                                  value={payload.anlage._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field === "Anlage"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("etage") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("etage")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      etage: e.target.value,
                                    })
                                  }
                                  value={payload.etage._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return dropdownOption.field === "Etage";
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes(
                              "kostenstelle"
                            ) && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("kostenstelle")}
                                </label>
                                <select
                                  required="true"
                                  id="owner"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      kostenstelle: e.target.value,
                                    })
                                  }
                                  value={payload.kostenstelle._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field ===
                                          "Kostenstelle"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("pos_nr") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("pos_nr")}
                                </label>
                                <input
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      pos_nr: e.target.value,
                                    })
                                  }
                                  value={payload.pos_nr}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("pos_name") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("pos_name")}
                                </label>
                                <input
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      pos_name: e.target.value,
                                    })
                                  }
                                  value={payload.pos_name}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes(
                              "leistungsbeschreibung_lang"
                            ) && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("leistungsbeschreibung_lang")}
                                </label>
                                <textarea
                                  required
                                  rows="3"
                                  type="textarea"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      leistungsbeschreibung_lang:
                                        e.target.value,
                                    })
                                  }
                                  value={payload.leistungsbeschreibung_lang}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes(
                              "leistungsbeschreibung_kurz"
                            ) && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("leistungsbeschreibung_kurz")}
                                </label>
                                <input
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      leistungsbeschreibung_kurz:
                                        e.target.value,
                                    })
                                  }
                                  value={payload.leistungsbeschreibung_kurz}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("menge") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("menge")}
                                </label>
                                <input
                                  required
                                  type="number"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      menge: e.target.value,
                                    })
                                  }
                                  value={payload.menge}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes(
                              "mengeneinheit"
                            ) && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("mengeneinheit")}
                                </label>
                                <select
                                  required="true"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      mengeneinheit: e.target.value,
                                    })
                                  }
                                  value={payload.mengeneinheit._id}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  {dropdownOptions &&
                                    dropdownOptions
                                      .filter((dropdownOption) => {
                                        return (
                                          dropdownOption.field ===
                                          "Mengeneinheit"
                                        );
                                      })
                                      .map((option) => (
                                        <option value={option._id}>
                                          {option.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("anzahl") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("anzahl")}
                                </label>
                                <input
                                  required
                                  type="number"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      anzahl: e.target.value,
                                    })
                                  }
                                  value={payload.anzahl}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("preis_1") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("preis_1")}
                                </label>
                                <input
                                  required
                                  type="number"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      preis_1: e.target.value,
                                    })
                                  }
                                  value={payload.preis_1}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("preis_2") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("preis_2")}
                                </label>
                                <input
                                  required
                                  type="number"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      preis_2: e.target.value,
                                    })
                                  }
                                  value={payload.preis_2}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("preis_3") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("preis_3")}
                                </label>
                                <input
                                  required
                                  type="number"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      preis_3: e.target.value,
                                    })
                                  }
                                  value={payload.preis_3}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                          {fieldData &&
                            fieldData.activatedFields &&
                            fieldData.activatedFields.includes("preis_4") && (
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  {translate("preis_4")}
                                </label>
                                <input
                                  required
                                  type="number"
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      preis_4: e.target.value,
                                    })
                                  }
                                  value={payload.preis_4}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="border-b my-5 border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className="px-4 py-3 bg-gray-50 sm:px-6">
                    Bestellungen
                    <a href={`/add-order/${id}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6 inline-flex my-2 mx-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                    </a>
                  </div>
                  <MaterialReactTable table={table} />
                </div>
              </div>
              <div class="col-span-1">
                <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className=" px-4 py-3 bg-gray-50 sm:px-6">Optionen</div>
                  <button
                    type="submit"
                    onClick={register}
                    className="mx-2 mt-5 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700"
                  >
                    Speichern
                  </button>
                  {fieldData.settings && fieldData.settings.enableQRCode && (
                    <Link
                      onClick={downloadQRCode}
                      to="#"
                      className="mx-2 my-5 inline-flex justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                    >
                      {translate("qr_code_download")}
                    </Link>
                  )}
                  {userData &&
                    userData.permissions &&
                    userData.permissions[project] &&
                    userData.permissions[project].isProjectAdmin && (
                      <>
                        <button
                          type="submit"
                          className=" mx-2 inline-flex my-3 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 "
                          onClick={() => {
                            setDeleteCall({
                              id,
                              open: true,
                            });
                          }}
                        >
                          Löschen
                        </button>
                      </>
                    )}
                  {error && (
                    <div
                      className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                      role="alert"
                    >
                      <svg
                        className="fill-current w-6 h-6 mr-3"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                      </svg>
                      <p>{translate("error_api")}</p>
                    </div>
                  )}
                </div>
                <div className="border-b my-3 border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className=" px-4 text-inline py-3 bg-gray-50 sm:px-6">
                    Automatische Bestellungen
                    <a href={`/add-auto-order/${id}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6 inline-flex my-2 mx-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      onClick={() => {
                        setExecuteAutoOrder({
                          ...executeAutoOrder,
                          open: true,
                        });
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6 inline-flex"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
                        />
                      </svg>
                    </a>
                  </div>

                  <div class="relative overflow-x-auto">
                    <table class="w-full text-sm text-left rtl:text-right">
                      <thead class="text-xs uppercase bg-gray-50 dark:bg-gray-100">
                        <tr>
                          <th scope="col" class="px-6 py-3">
                            Tag
                          </th>
                          <th scope="col" class="px-6 py-3">
                            Turnus
                          </th>
                          <th scope="col" class="px-6 py-3">
                            Start
                          </th>
                          <th scope="col" class="px-6 py-3">
                            Ende
                          </th>
                          <th scope="col" class="px-6 py-3">
                            Optionen
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {autoOrders.map((autoOrder) => (
                          <tr class="bg-white  dark:border-gray-700">
                            <th class="px-6 py-4">
                              {autoOrder.weekday}{" "}
                              {autoOrder.nachtschicht ? "(Nacht)" : ""}
                            </th>
                            <td class="px-6 py-4">{autoOrder.turnus}</td>
                            <td class="px-6 py-4">{autoOrder.startDate}</td>
                            <td class="px-6 py-4">
                              {autoOrder.endDate === "Invalid Date"
                                ? "offen"
                                : autoOrder.endDate}
                            </td>
                            <th class="px-6 py-4">
                              <a
                                href="#"
                                onClick={() => {
                                  setDeleteAutoOrder({
                                    orderId: autoOrder._id,
                                    open: true,
                                  });
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="size-6"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                  />
                                </svg>
                              </a>
                            </th>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {fieldData.settings && fieldData.settings.enableAttachments && (
                  <div className="border-b my-5 border-gray-200 shadow overflow-hidden sm:rounded-lg">
                    <div className="px-4 py-3 bg-gray-50 sm:px-6">
                      {translate("uploads")}
                    </div>
                    <ul className="mx-5">
                      {payload.attachments.map((url) => (
                        <a href={url} target="_blank">
                          <li>{url.split("/")[5]} </li>
                        </a>
                      ))}
                    </ul>
                    <hr className="my-3"></hr>
                    <form
                      onSubmit={uploadFile}
                      enctype="multipart/form-data"
                      className="mx-5"
                    >
                      <label
                        for="cover-photo"
                        class="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {translate("uploadNew")}
                      </label>
                      <div class="mt-2">
                        <input
                          required
                          type="file"
                          name="upload"
                          id="filePicker"
                          accept=".pdf, image/*"
                          onChange={(e) => setFile(e.target.files)}
                        />
                      </div>
                      <button
                        type="submit"
                        className="my-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Hochladen
                      </button>
                    </form>
                  </div>
                )}

                {payload && payload.anlage && (
                  <div style={{ visibility: "hidden" }}>
                    <QRCode
                      id="qrcode"
                      title="QR Code"
                      size="1000"
                      value={`ism.indutec-holding.de/scan/${payload.anlage._id}`}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {deleteCall.open && (
        <Transition.Root show={deleteCall.open} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={setDeleteCall}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Löschen bestätigen
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Sind Sie sich sicher, dass Sie das den Datensatz
                              unwiderruflich löschen möchten?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={deleteService}
                      >
                        Löschen
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() =>
                          setDeleteCall({
                            ...deleteCall,
                            open: false,
                          })
                        }
                      >
                        Abbrechen
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      {deleteOrder.open && (
        <Transition.Root show={deleteOrder.open} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={setDeleteOrder}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Bestellung stornieren
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Sind Sie sich sicher, dass Sie diese Bestellung
                              stornieren möchten?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={deleteOrderCall}
                      >
                        Stornieren
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() =>
                          setDeleteOrder({
                            ...deleteCall,
                            open: false,
                          })
                        }
                      >
                        Abbrechen
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}

      {deleteAutoOrder.open && (
        <Transition.Root show={deleteAutoOrder.open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={setDeleteAutoOrder}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Löschen bestätigen
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Sind Sie sich sicher, dass Sie das den Datensatz
                              unwiderruflich löschen möchten?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={deleteAutoOrderCall}
                      >
                        Löschen
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() =>
                          setDeleteAutoOrder({
                            ...deleteCall,
                            open: false,
                          })
                        }
                      >
                        Abbrechen
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      {executeAutoOrder.open && (
        <Transition.Root show={executeAutoOrder.open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={setExecuteAutoOrder}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Automatische Bestellungen ausführen?
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Bis zu welchem Datum sollen <b>alle</b>{" "}
                              automatischen Bestellungen ausgeführt werden?
                            </p>
                            <input
                              required
                              type="date"
                              onChange={(e) =>
                                setExecuteAutoOrder({
                                  ...executeAutoOrder,
                                  date: e.target.value,
                                })
                              }
                              value={executeAutoOrder.date}
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={executeAutoOrderCall}
                      >
                        Starten
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() =>
                          setExecuteAutoOrder({
                            date: "",
                            open: false,
                          })
                        }
                      >
                        Abbrechen
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </>
  );
}

export default EditService;
